<template>
  <teleport to="body">
    <transition name="fade">
      <div v-if="visible" class="overlay" @click.self="close" tabindex="0">
        <div class="card">
          <h3 class="title">{{ title }}</h3>
          <p class="message">{{ message }}</p>
          <button class="btn" @click="close">Ок</button>
        </div>
      </div>
    </transition>
  </teleport>
</template>

<script setup>
import { watch, onBeforeUnmount } from 'vue';

const props = defineProps({
  visible: { type: Boolean, default: false },
  title:   { type: String, default: 'Ошибка' },
  message: { type: String, default: 'Что-то пошло не так.' },
  autoCloseMs: { type: Number, default: 0 }
});
const emit = defineEmits(['close']);

let timer = null;
const startTimer = () => {
  if (!props.autoCloseMs) return;
  clearTimeout(timer);
  timer = setTimeout(() => emit('close'), props.autoCloseMs);
};
const close = () => {
  clearTimeout(timer);
  emit('close');
};
watch(() => props.visible, v => v && startTimer());
onBeforeUnmount(() => clearTimeout(timer));
</script>

<style scoped>
/* плавное появление */
.fade-enter-active, .fade-leave-active { transition: opacity .18s ease; }
.fade-enter-from, .fade-leave-to { opacity: 0; }

/* фон */
.overlay {
  position: fixed;
  inset: 0;
  backdrop-filter: blur(6px);
  background: rgba(0,0,0,0.35); /* прозрачный тёмный слой */
  display: grid;
  place-items: center;
  z-index: 10000;
}

/* карточка — максимально проста и «воздушна» */
.card {
  width: 360px;
  max-width: calc(100vw - 40px);
  padding: 20px 18px 16px;
  border-radius: 18px;
  background: rgba(255,255,255,0.06);     /* почти прозрачная */
  border: 1px solid rgba(255,255,255,0.18);
  color: #fff;
  text-align: center;
}

/* светлая тема — прозрачная, но читаемая */
:root[data-theme="light"] .card {
  background: rgba(255,255,255,0.6);
  color: #111;
  border: 1px solid rgba(0,0,0,0.08);
}

.title {
  margin: 0 0 6px;
  font-family: "Eastman-Bold", sans-serif;
  font-size: 16px;
}
.message {
  margin: 0 0 14px;
  font-family: "Eastman-Regular", sans-serif;
  font-size: 13px;
  opacity: .95;
}

/* одна красивая кнопка */
.btn {
  width: 100%;
  border: none;
  border-radius: 12px;
  padding: 12px 16px;
  font-family: "Eastman-Medium", sans-serif;
  font-size: 14px;
  color: #fff;
  cursor: pointer;
  background: linear-gradient(90deg, #2277E6, #8247E2);
  transition: transform .06s ease, opacity .2s ease;
}
.btn:active { transform: translateY(1px); }
</style>